
import { useSupabaseCount, CountResult } from "./useSupabaseCount";

export function useCategoryCount(): CountResult {
  return useSupabaseCount("categories", "category-count");
}
